import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function LoyalClients() {
  return (
    <section
      data-testid="loyal-clients-section"
      className="relative mx-auto max-w-5xl px-5 py-24 md:px-10 md:py-36"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1, ease: EASE }}
        className="relative border border-gold/25 bg-coal px-6 py-12 md:px-16 md:py-16"
      >
        <span className="absolute -left-px -top-px h-8 w-8 border-l-2 border-t-2 border-gold" />
        <span className="absolute -right-px -top-px h-8 w-8 border-r-2 border-t-2 border-gold" />
        <span className="absolute -bottom-px -left-px h-8 w-8 border-b-2 border-l-2 border-gold" />
        <span className="absolute -bottom-px -right-px h-8 w-8 border-b-2 border-r-2 border-gold" />

        <p className="text-center text-[11px] uppercase tracking-[0.3em] text-gold/90">
          À l'attention de nos clients fidèles
        </p>

        <p className="font-accent mt-8 text-center text-2xl italic text-champagne">
          Cher client fidèle,
        </p>

        <p className="font-display mt-6 text-center text-xl leading-relaxed text-bone md:text-2xl">
          Ce lien vous a été envoyé en avant-première, parce que vous faites
          partie des nôtres. Votre fidélité mérite plus qu'un merci : elle
          mérite une table qui vous attend, une soirée qui vous ressemble, et
          le Lillet Spritz offert pendant toute la durée du couvre-feu.
        </p>

        <p className="mt-8 text-center text-sm leading-relaxed text-zinc-400">
          Présentez le SMS reçu à votre arrivée : tout est déjà prévu pour
          vous.
        </p>

        <p className="font-display mt-10 text-right text-xl italic text-gold">
          À très vite,
          <br />
          Le groupe All For You
        </p>
      </motion.div>
    </section>
  );
}
